import React, { FC, useContext, useState } from 'react';
import { SimplePopover } from '@dev/ee-components';
import { isEmpty } from 'lodash-es';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import { isLogsScreen } from '@api/components/Logs/helperFunctions';
import { parseUrlParams } from '@api/services/tools/handleUrlParams';
import { LogTypesString } from '@api/store/logs/types';

import { GlobalFilterOptionsContext } from '../../..';
import { DropdownFilterType } from '../../../LogsFiltersBarInterfaces';
import { useChannelPopoverOptions } from '@api/components/Logs/hooks/useChannelPopoverOptions';
import { TrimLengthWrapper } from '@api/components/Logs/assets/styledComponents';
import { INITIAL_PER_PAGE } from '@api/store/exports/types';
import { debounce } from '@api/services/tools/debounce';
import { useSelector } from 'react-redux';
import { getChannelsStore } from '@api/store/channels/actions';

export const ChannelFilter: FC<DropdownFilterType> = ({ selectedChannel }: DropdownFilterType): JSX.Element => {
    const { t } = useTranslation();
    const location = useLocation();
    const [search, setSearch] = useState('');
    const { channel } = parseUrlParams(location.search);
    const { hasMore, loading } = useSelector(getChannelsStore) || {};
    const { onClicks, updateFilters, logScreenType, availableFilters, fetchNextChannels } = useContext(GlobalFilterOptionsContext);
    const channelsToShow = useChannelPopoverOptions(search);

    const pickedChannel = selectedChannel ?? (channel as string);

    const onChannelFilterClick = (
        _event: React.MouseEvent<HTMLInputElement, MouseEvent>,
        pickedItem: { value: string; label: string }
    ): void => {
        const isAll = pickedItem.value === 'all';
        const selectedChannel = isAll ? null : pickedItem.value;

        const updatedFilters = {
            channel: selectedChannel,
            campaign: null,
            statuses: null,
        };
        updateFilters(updatedFilters);
        onClicks?.channelFilter(_event, pickedItem);
    };

    const enabledChannelFilter = isLogsScreen(LogTypesString.EMAIL, logScreenType) && !(isEmpty(channelsToShow) && !search);

    if (!(availableFilters?.channel ?? true) || !enabledChannelFilter) {
        return <></>;
    }
    return (
        <TrimLengthWrapper>
            <SimplePopover
                type="noborder"
                value={pickedChannel}
                options={channelsToShow}
                onItemClick={onChannelFilterClick}
                defaultPlaceholder={t('channel')}
                maxHeight={400}
                listItemWidth="400px"
                listItemMaxLines={3}
                infiniteScrollProps={{
                    next: () => fetchNextChannels(search),
                    hasMore: hasMore ?? true,
                    dataLength: channelsToShow?.length || INITIAL_PER_PAGE,
                }}
                rowsPerChunk={INITIAL_PER_PAGE}
                cachedListSize={1}
                onOptionSearch={(ev) => {
                    const target = ev?.target?.value;

                    debounce(() => {
                        setSearch(target);
                        fetchNextChannels(target, 0);
                    });
                }}
                keepSearchPhrase
                isLoadingOptions={loading}
            />
        </TrimLengthWrapper>
    );
};
